import type { components } from 'generated/api'
import Api from 'utils/api'

type Schemas = components['schemas']

export type ProjectTemplate = Schemas['ProjectTemplate']
export type ProjectTemplatePayload = Schemas['ProjectTemplateCreateRequest']
export type ProjectTemplateUpdatePayload =
  Schemas['PatchedProjectTemplateCreateRequest']

export const fetchProjectTemplates = ({
  limit,
  offset,
  ordering,
  search,
}: {
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
}) => Api.get(['projecttemplates'], { limit, offset, ordering, search })

export const postCopyProjectTemplate = ({
  title,
  department,
  uuid,
}: {
  title: string
  department?: number | string
  uuid: string
}) => Api.post(['projecttemplates', uuid, 'copy'], { title, department })

export const postProjectTemplate = (payload: ProjectTemplatePayload) =>
  Api.post(['projecttemplates'], payload)

export const updateProjectTemplate = (
  id: string | number,
  payload: ProjectTemplateUpdatePayload,
) => Api.patch(['projecttemplates', id], payload)
